<template>
  <div class="buypileh5-Container" >
    <img class="bg" :src="bg" alt="" >
    <div class="area">
      <!-- <div class="btn" @click="downloadImg"></div> -->
    <img class="qrcode" src="../assets/qrcode.png" alt="">
    </div>
    
  </div>
</template>

<script>
export default {
  data(){
    return {
      bg:'http://mambike.oss-cn-beijing.aliyuncs.com/shougoulive/charge/buypile-invitation.png?tem=' + Date.now(),
    }
  },
  methods:{
    // downloadImg(){ //保存图片
    // console.log('dianji');
    //  this.$Toast('保存中');
    //    var image = new Image()
    // // 解决跨域 Canvas 污染问题
    // image.setAttribute('crossOrigin', 'anonymous')
    // image.onload = function () {
    //     var canvas = document.createElement('canvas')
    //     canvas.width = image.width
    //     canvas.height = image.height

    //     var context = canvas.getContext('2d')
    //     context.drawImage(image, 0, 0, image.width, image.height)
    //     var url = canvas.toDataURL('image/png')

    //     // 生成一个a元素
    //     var a = document.createElement('a')
    //     // 创建一个单击事件
    //     var event = new MouseEvent('click')

    //     // 将a的download属性设置为我们想要下载的图片名称，若name不存在则使用‘下载图片名称’作为默认名称
    //     let name = '小程序二维码'
    //     a.download = name || '下载图片名称'
    //     // 将生成的URL设置为a.href属性
    //     a.href = url
    //     console.log(url);
    //     // 触发a的单击事件
    //     a.dispatchEvent(event)
    // }
    //  console.log(document.querySelector('.qrcode').src);
    // image.src = document.querySelector('.qrcode').src

    // }
  }
   
}
</script>

<style lang="less" scoped> 
.buypileh5-Container{
    position: relative;
   .bg{
       width: 100%;
       position: absolute;
       left: 0;
       top: 0;
   }
  .area{
      position: relative;
      width: 100%;
      height: 39rem;
  }
  // .btn{
  //   position: absolute;
  //   z-index: 100000;
  //   width: 2rem;
  //   height: .8rem;
  //   top:11.8rem;
  //   left: 2.75rem;
  //   background-color: black;
  // }
  .qrcode{
      opacity: 0;
      position: absolute;
      width: 3.80rem;
      left: 1.85rem;
      top:8.06rem;
      z-index: 1111;
  }
}
</style>